import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { toast } from '../components/ui/sonner';
import { Toaster } from '../components/ui/sonner';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login(email, password);
      if (result.success) {
        toast.success('Login efetuado com sucesso!');
        navigate('/dashboard');
      } else {
        toast.error(result.error || 'Erro ao efetuar login');
      }
    } catch (error) {
      toast.error('Erro ao efetuar login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#003D7A] via-[#004A94] to-[#0056A8] flex items-center justify-center p-4">
      <Toaster />
      <Card className="w-full max-w-md shadow-2xl">
        <CardHeader className="space-y-4 text-center pb-6">
          <div className="flex justify-center">
            <img 
              src="/logo-ip.png" 
              alt="Infraestruturas de Portugal" 
              className="h-16 object-contain"
            />
          </div>
          <CardTitle className="text-2xl font-bold text-gray-800">
            Plataforma de Gestão Técnica
          </CardTitle>
          <CardDescription className="text-gray-600">
            Aceda com as suas credenciais
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="nome@infraestruturasdeportugal.pt"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="transition-all focus:ring-2 focus:ring-[#003D7A]"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Palavra-passe</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="transition-all focus:ring-2 focus:ring-[#003D7A]"
              />
            </div>
            <Button 
              type="submit" 
              className="w-full bg-[#003D7A] hover:bg-[#002855] transition-all"
              disabled={loading}
            >
              {loading ? 'A entrar...' : 'Entrar'}
            </Button>
          </form>
          <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
            <p className="text-xs text-gray-600 text-center">
              <strong>Demo:</strong> Use qualquer email e palavra-passe para aceder
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
